/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamRevisionBotexamidVisualizeQueryResponse,
  GetApiV1ExamRevisionBotexamidVisualizePathParams,
  GetApiV1ExamRevisionBotexamidVisualizeQueryParams,
  GetApiV1ExamRevisionBotexamidVisualize400,
  GetApiV1ExamRevisionBotexamidVisualize401,
  GetApiV1ExamRevisionBotexamidVisualize404,
  GetApiV1ExamRevisionBotexamidVisualize500,
} from "../../types/examRevisionController/GetApiV1ExamRevisionBotexamidVisualize.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamRevisionBotexamidVisualize } from "../../clients/examRevisionController/getApiV1ExamRevisionBotexamidVisualize.ts";

export const getApiV1ExamRevisionBotexamidVisualizeQueryKey = (
  botExamId: GetApiV1ExamRevisionBotexamidVisualizePathParams["botExamId"],
  params?: GetApiV1ExamRevisionBotexamidVisualizeQueryParams,
) =>
  [
    {
      url: "/api/v1/exam/revision/:botExamId/visualize",
      params: { botExamId: botExamId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamRevisionBotexamidVisualizeQueryKey = ReturnType<
  typeof getApiV1ExamRevisionBotexamidVisualizeQueryKey
>;

export function getApiV1ExamRevisionBotexamidVisualizeQueryOptions(
  botExamId: GetApiV1ExamRevisionBotexamidVisualizePathParams["botExamId"],
  params?: GetApiV1ExamRevisionBotexamidVisualizeQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamRevisionBotexamidVisualizeQueryKey(
    botExamId,
    params,
  );
  return queryOptions<
    GetApiV1ExamRevisionBotexamidVisualizeQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamRevisionBotexamidVisualize400
      | GetApiV1ExamRevisionBotexamidVisualize401
      | GetApiV1ExamRevisionBotexamidVisualize404
      | GetApiV1ExamRevisionBotexamidVisualize500
    >,
    GetApiV1ExamRevisionBotexamidVisualizeQueryResponse,
    typeof queryKey
  >({
    enabled: !!botExamId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamRevisionBotexamidVisualize(botExamId, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados completos de visualização de uma prova gerada por IA, incluindo título, instrução e todas as questões em pt-BR com suas traduções para outros idiomas. **(Requer Authorization para autenticação)**
 * @summary Visualizar prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/:botExamId/visualize}
 */
export function useGetApiV1ExamRevisionBotexamidVisualize<
  TData = GetApiV1ExamRevisionBotexamidVisualizeQueryResponse,
  TQueryData = GetApiV1ExamRevisionBotexamidVisualizeQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamRevisionBotexamidVisualizeQueryKey,
>(
  botExamId: GetApiV1ExamRevisionBotexamidVisualizePathParams["botExamId"],
  params?: GetApiV1ExamRevisionBotexamidVisualizeQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamRevisionBotexamidVisualizeQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamRevisionBotexamidVisualize400
          | GetApiV1ExamRevisionBotexamidVisualize401
          | GetApiV1ExamRevisionBotexamidVisualize404
          | GetApiV1ExamRevisionBotexamidVisualize500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamRevisionBotexamidVisualizeQueryKey(botExamId, params);

  const query = useQuery(
    {
      ...getApiV1ExamRevisionBotexamidVisualizeQueryOptions(
        botExamId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamRevisionBotexamidVisualize400
      | GetApiV1ExamRevisionBotexamidVisualize401
      | GetApiV1ExamRevisionBotexamidVisualize404
      | GetApiV1ExamRevisionBotexamidVisualize500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
